import DragCamera from "./DragCamera";

export default class Keyboard {
  constructor(dragCamera, dragToolManager, drawingToolKit, selection, toolSection, toggleHelp) {
    this._dragCamera = dragCamera;
    this._dragToolManager = dragToolManager;
    this._drawingToolKit = drawingToolKit;
    this._selection = selection;
    this._toolSection = toolSection;
    this._toggleHelp = toggleHelp;
    this._keyCount = {};
    this._codeCount = {};
    this._tmpDragCamera = null;
    this.reverseKeyMove = 1;

    window.addEventListener('blur', this._resetKeyCount.bind(this));
    document.addEventListener('paste', this._handlePaste.bind(this));
    document.addEventListener('keydown', this._handleKeydown.bind(this));
    document.addEventListener('keyup', this._handleKeyup.bind(this));
    setInterval(this._updateKeyMove.bind(this), DragCamera.frameTime);
  }
  //--- bodyつまり全体が使用不可状態かどうか
  isBodyWaiting() {
    return document.body.className.indexOf('dontTouch') === 0;
  }
  _resetKeyCount() {
    this._keyCount = {};
    this._codeCount = {};
  }
  _handlePaste(e) {
    if(this._keyCount['v'] > 1) return;
    if(this.isBodyWaiting()) return;
    if(!this._dragToolManager.isFree()) return;
    this._selection.pasteFromClipboard(e).then(() => this._toolSection.setMode('selection'));
  }
  _handleKeydown(e) {
    //console.log('keydown:' + e.key);
    let returnFlag = false;
    if(!(e.key in this._keyCount)) {
      this._keyCount[e.key] = 1;
    } else {
      ++this._keyCount[e.key];
      returnFlag = true;
    }
    if(!(e.code in this._codeCount)) {
      this._codeCount[e.code] = 1;
    } else {
      ++this._codeCount[e.code];
      returnFlag = true;
    }
      
    // Macのoptionと同時押ししたキーのkeyupが呼ばれない問題への対策
    if(e.metaKey && e.key !== 'Meta') {
      setTimeout(() => {
        //console.log('reset: ' + e.key);
        if(--this._keyCount[e.key] <= 0) delete this._keyCount[e.key];
        if(--this._codeCount[e.code] <= 0) delete this._codeCount[e.code];
      }, 100);
    }
    
    if(!returnFlag && !this.isBodyWaiting()) {
      if(e.key === 'Control' || e.key === 'Meta') {
        if(this._selection.maintainAspectRatio === 0) this._selection.maintainAspectRatio = 2;
        this._drawingToolKit.penForce1px = !this._drawingToolKit.penForce1px;
        this._dragToolManager.updateCursor();
      }
  
      if(!this._dragToolManager.isFree()) return;

      if(e.ctrlKey || e.metaKey){
        switch(e.key) {
        case 'c':
          this._selection.exec('copy');
          break;
        case 'x':
          this._selection.exec('cut');
          break;
        case 'z':
        case 'Z':
          if(e.shiftKey) {
            this._toolSection.redo();
          } else {
            this._toolSection.undo();
          }
          break;
        case 'y':
          this._toolSection.redo();
          break;
        case 'a':
          this._selection.selectAll(() => this._toolSection.setMode('selection'));
          break;
        case 's':
          document.querySelector('#toolOptionGroup button[name="downloadPXARCH"]').click();
          break;
        case 'l':
          document.querySelector('#toolOptionGroup button[name="openPXARCHButton"]').click();
          break;
        case 'Control':
        case 'Meta':
          this._selection.toggleMode = true;
          this._dragToolManager.updateCursor();
          break;
        }
      } else {
        switch(e.key) {
        case 'Delete':
          this._selection.exec('clear');
          break;
        case 'Alt':
          this._drawingToolKit.setMode('eyedropper');
          this._dragToolManager.updateCursor();
          break;
        case 'F1':
          this._toggleHelp();
          break;
        case 'F11':
          if(document.fullscreenElement) {
            document.exitFullscreen();
          } else {
            document.documentElement.requestFullscreen();
          }
          break;
        }
      }
    }
    this._preventDefaults(e);
  }
  _preventDefaults(e) {
    if(e.ctrlKey || e.metaKey){
      switch(e.key) {
      case 'z':
      case 'Z':
      case 'y':
      case 'a':
      case 's':
      case 'l':
        e.preventDefault();
        break;
      }
    } else {
      switch(e.key) {
      case 'Delete':
      case 'Alt':
      case 'F1':
      case 'F11':
        e.preventDefault();
        break;
      }
    }
  }
  _handleKeyup(e) {
    //console.log('keyup:' + e.key);
    if(e.key in this._keyCount) delete this._keyCount[e.key];
    if(e.code in this._codeCount) delete this._codeCount[e.code];
    if(e.key === 'Control' || e.key === 'Meta') {
      if(this._selection.maintainAspectRatio === 2) this._selection.maintainAspectRatio = 0;
      this._drawingToolKit.penForce1px = !this._drawingToolKit.penForce1px;
      this._dragToolManager.updateCursor();
    }
  
    if(!this._dragToolManager.isFree()) return;
  
    switch(e.key) {
    case 'Alt':
      this._drawingToolKit.revertMode();
      this._dragToolManager.updateCursor();
      e.preventDefault();
      break;
    case 'Control':
    case 'Meta':
      this._selection.toggleMode = false;
      this._dragToolManager.updateCursor();
      break;
    }
  }
  setTmpDragCamera(dragCamera, target) {
    this._dragCamera.resetSlideVel();
    this._tmpDragCamera = dragCamera;

    target.addEventListener('mouseleave', () => {
      this._tmpDragCamera.resetSlideVel();
      this._tmpDragCamera = null;
    }, {once: true});
  }
  _updateKeyMove() {
    if(this._keyCount.Control) return;
    if(this._keyCount.Meta) return;
    if(document.activeElement.type === 'text') return;

    const dragCamera = this._tmpDragCamera ?? this._dragCamera;

    if(this._codeCount.KeyA) {
      dragCamera.updatePosX(-1 * this.reverseKeyMove);
    } else if(this._codeCount.KeyD) {
      dragCamera.updatePosX(1 * this.reverseKeyMove);
    } else {
      dragCamera.updatePosX(0);
    }
    if(this._codeCount.KeyW) {
      dragCamera.updatePosY(-1 * this.reverseKeyMove);
    } else if(this._codeCount.KeyS) {
      dragCamera.updatePosY(1 * this.reverseKeyMove);
    } else {
      dragCamera.updatePosY(0);
    }
    if(this._codeCount.KeyQ) {
      const {x, y} = dragCamera.localCenterPos;
      dragCamera.wheel({x, y, deltaY: 20});
    }
    if(this._codeCount.KeyE) {
      const {x, y} = dragCamera.localCenterPos;
      dragCamera.wheel({x, y, deltaY: -20});
    }
  }
  get arrowKeys() {
    const l = this._codeCount.ArrowLeft > 0;
    const r = this._codeCount.ArrowRight > 0;
    const u = this._codeCount.ArrowUp > 0;
    const d = this._codeCount.ArrowDown > 0;
    return {
      l, r, u, d,
      any: l || r || u || d
    };
  }
}
